import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ReactQuill from 'react-quill'; 
import 'react-quill/dist/quill.snow.css';
import { Container, Typography, TextField, Button, Box, Snackbar, Alert } from '@mui/material';
import { useParams } from 'react-router-dom';
import MediaUploadField from '../MediaUploadField';

const modules = {
    toolbar: [
        [{ 'font': [] }],
        [{ 'header': '1' }, { 'header': '2' }],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ 'color': [] }, { 'background': [] }],
        [{ 'align': [] }],
        ['link', 'image', 'blockquote', 'code-block'],
        ['clean'],
    ],
};
const EditarVerbetes = ({ match }) => {
    const { id } = useParams(); // Agora você pode acessar o parâmetro 'id' da URL

    const apiUrl = process.env.REACT_APP_API_URL;
     const [formData, setFormData] = useState({
            titulo: '',
            autor: '',
            imgcard: '',
            instituicaoautor: '',
            linkpdfverbete: '',
            linkpdfdoclink: '',
            edicoes: [],
            trechoTraduzidoModernizado: '',
            palavrachave: [],
            autorDocumento: '',
            nomeDocumento: '',
            dataComposicao: '',
            lugarComposicaoOuImpressao: '',
            imagemDocumento: '',
            textoPortugues: '',
            textoEspanhol: '',
            nomeImagemDocumento: '',
            id: null,  // Para edição
        });
    const [alertMessage, setAlertMessage] = useState({ type: '', text: '' });
    const [openSnackbar, setOpenSnackbar] = useState(false);

    useEffect(() => {
        const loadVerbete = async () => {
            try {
                const response = await axios.get(`${apiUrl}/verbetes/${id}`);
                setFormData(response.data);
            } catch (error) {
                console.error(error);
                setAlertMessage({ type: 'error', text: 'Erro ao carregar verbete para edição.' });
                setOpenSnackbar(true);
            }
        };
        loadVerbete();
    }, [apiUrl, id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };
    const setFieldValue = (name, value) => {
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleConteudoChange = (campo, valor) => {
        if (formData[campo] !== valor) {
            setFormData(prevState => ({
                ...prevState,
                [campo]: valor,
            }));
        }
    };
    

    const handleSubmit = async (e) => {
        e.preventDefault();
    
        const token = localStorage.getItem('token');
        if (!token) {
            setAlertMessage({ type: 'error', text: 'Você precisa estar autenticado para editar o verbete.' });
            setOpenSnackbar(true);
            return;
        }
    
        try {
            const response = await axios.put(`${apiUrl}/verbetes/${id}`, formData, {
                headers: { Authorization: `Bearer ${token}` },
            });
            console.log('Resposta do servidor:', response); // Log da resposta do servidor
            setAlertMessage({ type: 'success', text: 'Verbete atualizado com sucesso!' });
            setOpenSnackbar(true);
        } catch (error) {
            console.error('Erro ao atualizar verbete:', error); // Log do erro completo
            setAlertMessage({ type: 'error', text: 'Erro ao atualizar verbete. Tente novamente.' });
            setOpenSnackbar(true);
        }
    };
    

    const handleCloseSnackbar = () => setOpenSnackbar(false);
    const handleUploadError = (message) => {
        setAlertMessage({ type: 'error', text: message });
        setOpenSnackbar(true);
    };
    const handleUploadSuccess = (message) => {
        setAlertMessage({ type: 'success', text: message });
        setOpenSnackbar(true);
    };

    return (
        <Container maxWidth="lg">
       
       <hr style={{ margin: '40px 0', borderTop: '1px solid #ddd' }} />
       <hr style={{ margin: '40px 0', borderTop: '1px solid #ddd' }} />
       
       <Typography
                       variant="h2"
                       align="center"
                       gutterBottom
                       style={{
                           fontFamily: "'Lato', serif",
                           color: "black",
                           borderBottom: "4px solidrgb(8, 8, 7)",
                           paddingBottom: "10px",
                           textTransform: "uppercase",
                           borderBottom: "4px solid #d4af37",
                           animation: "glow 2s infinite alternate",
                           marginTop: "7%"  // Aqui é onde você define o espaço superior
                       }}
                   > 
                       Edição do Verbete
                   </Typography>
                   
                   
                       <form onSubmit={handleSubmit}>
                           <Typography variant="h5" align="center" gutterBottom>
                               {formData.id ? 'Editar Verbetes' : 'Adicionar Novo Verbetes'}
                           </Typography>
                           
                           <Box mb={3}>
                               <TextField
                                   fullWidth
                                   label="Título"
                                   variant="outlined"
                                   name="titulo"
                                   value={formData.titulo}
                                   onChange={handleChange}
                                   required
                               />
                           </Box>
                           
                           <Box mb={3}>
                               <TextField
                                   fullWidth
                                   label="Autor"
                                   variant="outlined"
                                   name="autor"
                                   value={formData.autor}
                                   onChange={handleChange}
                                   required
                               />
                           </Box>
       
                           <Box mb={3}>
                               <TextField
                                   fullWidth
                                   label="Instituição do Autor"
                                   variant="outlined"
                                   name="instituicaoautor"
                                   value={formData.instituicaoautor}
                                   onChange={handleChange}
                                   required
                               />
                           </Box>
       
                           <Box mb={3}>
                               <MediaUploadField
                                   label="Imagem do Card"
                                   name="imgcard"
                                   value={formData.imgcard}
                                   onChange={setFieldValue}
                                   folder="imagenscards"
                                   accept="image/*"
                                   required
                                   onError={handleUploadError}
                                   onSuccess={handleUploadSuccess}
                               />
                           </Box>
       
                           <Box mb={3}>
                               <MediaUploadField
                                   label="PDF do Verbete"
                                   name="linkpdfverbete"
                                   value={formData.linkpdfverbete}
                                   onChange={setFieldValue}
                                   folder="verbetes"
                                   accept=".pdf,application/pdf"
                                   required
                                   onError={handleUploadError}
                                   onSuccess={handleUploadSuccess}
                               />
                           </Box>
       
                           <Box mb={3}>
                               <TextField
                                   fullWidth
                                   label="edicoes"
                                   variant="outlined"
                                   name="edicoes"
                                   value={formData.edicoes}
                                   onChange={handleChange}
                                   required
                               />
                           </Box>
       
                           <Box mb={3}>
                               <TextField
                                   fullWidth
                                   label="palavrachave"
                                   variant="outlined"
                                   name="palavrachave"
                                   value={formData.palavrachave}
                                   onChange={handleChange}
                                   required
                               />
                           </Box>
                            
                            
       
       
                           <Box mb={3}>
                               <MediaUploadField
                                   label="PDF do Documento"
                                   name="linkpdfdoclink"
                                   value={formData.linkpdfdoclink}
                                   onChange={setFieldValue}
                                   folder="pdfDoc"
                                   accept=".pdf,application/pdf"
                                   required
                                   onError={handleUploadError}
                                   onSuccess={handleUploadSuccess}
                               />
                           </Box>
       
                           <Box mb={3}>
                               <TextField
                                   fullWidth
                                   label="Autor do Documento"
                                   variant="outlined"
                                   name="autorDocumento"
                                   value={formData.autorDocumento}
                                   onChange={handleChange}
                               />
                           </Box>
       
                           <Box mb={3}>
                               <TextField
                                   fullWidth
                                   label="Nome do Documento"
                                   variant="outlined"
                                   name="nomeDocumento"
                                   value={formData.nomeDocumento}
                                   onChange={handleChange}
                               />
                           </Box>
       
                           <Box mb={3}>
                               <TextField
                                   fullWidth
                                   label="Data de Composição"
                                   variant="outlined"
                                   name="dataComposicao"
                                   value={formData.dataComposicao}
                                   onChange={handleChange}
                               />
                           </Box>
       
                           <Box mb={3}>
                               <TextField
                                   fullWidth
                                   label="Lugar de Composição ou Impressão"
                                   variant="outlined"
                                   name="lugarComposicaoOuImpressao"
                                   value={formData.lugarComposicaoOuImpressao}
                                   onChange={handleChange}
                               />
                           </Box>
       
                           <Box mb={3}>
                               <MediaUploadField
                                   label="Imagem do Documento"
                                   name="imagemDocumento"
                                   value={formData.imagemDocumento}
                                   onChange={setFieldValue}
                                   folder="imagensverbete"
                                   accept="image/*"
                                   onError={handleUploadError}
                                   onSuccess={handleUploadSuccess}
                               />
                           </Box>
       
                           <Box mb={3}>
                               <TextField
                                   fullWidth
                                   label="Nome Local da imagem Documento, exemplo:  Imagem do prólogo, edição de Sevilha, 1498. Manuscrito da Biblioteca Nacional de Espanha."
                                   variant="outlined"
                                   name="nomeImagemDocumento"
                                   value={formData.nomeImagemDocumento}
                                   onChange={handleChange}
                               />
                           </Box>
       
                            
                           
       
                           <Box mb={5}>
           <Typography variant="body1" gutterBottom>
               Trecho Traduzido e Modernizado:
           </Typography>
           <ReactQuill
   value={formData.trechoTraduzidoModernizado}
   onChange={(value) => {
       if (formData.trechoTraduzidoModernizado !== value) {
           handleConteudoChange('trechoTraduzidoModernizado', value);
       }
   }}
   theme="snow"
   modules={modules}
   style={{ height: '300px' }}
/>
       </Box>
       
       <Box mb={5}>
           <Typography variant="body1" gutterBottom>
               Conteúdo Texto em Portugues:
           </Typography>
           <ReactQuill
   value={formData.textoPortugues}
   onChange={(value) => {
       if (formData.textoPortugues !== value) {
           handleConteudoChange('textoPortugues', value);
       }
   }}
   theme="snow"
   modules={modules}
   style={{ height: '300px' }}
/>
       </Box>
       
       <Box mb={5}>
           <Typography variant="body1" gutterBottom>
               Conteúdo Texto em Outro idioma:
           </Typography>
           <ReactQuill
   value={formData.textoEspanhol}
   onChange={(value) => {
       if (formData.textoEspanhol !== value) {
           handleConteudoChange('textoEspanhol', value);
       }
   }}
   theme="snow"
   modules={modules}
   style={{ height: '300px' }}
/>
       </Box>
       
       
                            
       
        
       
                           <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleCloseSnackbar}>
           <Alert onClose={handleCloseSnackbar} severity={alertMessage.type} sx={{ width: '100%' }}>
               {alertMessage.text}
           </Alert>
       </Snackbar>
       <Box mb={3}>
           <Button
               fullWidth
               variant="contained"
               color="primary"
               type="submit"
               onClick={handleSubmit}
           >
               {formData.id ? 'Atualizar Verbete' : 'Atualizar Verbete'}
           </Button>
       </Box>
       
                       </form>
                   
       
        
                        
                    
               </Container>
    )
};

export default EditarVerbetes;
